import { NgModule } from '@angular/core';
import { MatInputModule } from '@angular/material';
import { SharedModule } from "@app/shared";
import { MaterialModule } from '@app/shared/material.module';
import {
  CreditVettingModalComponent,
  DebterListComponent,
  DomesticWorkersComponent,
  KeyholderInfoComponent,
  OpenAndCloseMonitoringComponent,
  PasswordFlowComponent, SearchServiceDebterComponent, ServiceSalesInstallationAgreementRoutingModule,
  SiteHazardComponent, VerificationReportModalComponent
} from '@sales/components/task-management/service-installation-agreement';
import { GaugeChartModule } from 'angular-gauge-chart';
import { SalesModule } from '../../../sales.module';
import { LeadLifecycleReusableComponentsModule } from '../../lead-header';
import { serviceAgreementComponentDeclarations } from './';

const entryComponents = [CreditVettingModalComponent, VerificationReportModalComponent,
  DebterListComponent, SearchServiceDebterComponent];
@NgModule({
  declarations: [...serviceAgreementComponentDeclarations, ...entryComponents],
  imports: [
    MaterialModule, SharedModule, ServiceSalesInstallationAgreementRoutingModule,
    MatInputModule,
    LeadLifecycleReusableComponentsModule,
    GaugeChartModule, SalesModule
  ],
  exports: [KeyholderInfoComponent, DomesticWorkersComponent, OpenAndCloseMonitoringComponent,
    PasswordFlowComponent, SiteHazardComponent],
  entryComponents
})
export class ServiceSalesInstallationAgreementModule { }
